

export const index = 4;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/admin/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/4.BXrOUIHf.js","_app/immutable/chunks/Bzak7iHL.js","_app/immutable/chunks/CnGaPG_y.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/CAN0e4T3.js","_app/immutable/chunks/BBilxCvN.js","_app/immutable/chunks/7JdHMB9Z.js","_app/immutable/chunks/BqhvobEz.js","_app/immutable/chunks/_szDWC-1.js","_app/immutable/chunks/GZ8OcxnQ.js","_app/immutable/chunks/Dsy9VFq4.js"];
export const stylesheets = [];
export const fonts = [];
